// extracted by mini-css-extract-plugin
export default {"filter-scroll":"table-filter-root_filter-scroll__BKIUU","filter-table-container":"table-filter-root_filter-table-container__AaEhO"};